import React, { useEffect, useState } from "react";
import {connect} from "react-redux";
import {getCurriculumData,getTermsData, getCourseCurriculumData, getManageTopicAndTloData } from "../../../redux/actions/dataAction";
import CustomTableWithAll from "../../../constants/CustomTableWithAll";
import CustomHeading from "../../../constants/CustomHeading";
import CustomDropdown from '../../../constants/CustomDropdown';
import CustomFilter from '../../../constants/CustomFilter';


const Manage_Topic_Tlos = (props) => {

	useEffect(() => {
		props.getCurriculumData()
		props.getCourseCurriculumData()
		props.getTermsData()
		props.getManageTopicAndTloData()
	}, [])

	const [filter,setFilter]=useState({
		term:'Select Term',
		curriculum:'Select Curriculum',
		course:'Select Course'
	})

	const handleChange=(event)=>{
		setFilter(({...filter,[event.target.id]:event.target.value}))  
	}



	const [filterCourseData,setFilterCourseData]=useState([]);
	const [filterData,setFilterData]=useState([]);

	const Filter=()=>{
		let term_data= CustomFilter(props?.course_curriculum?.data,[
			{value:filter.term,label:'term',initial_value:'Select Term'},
			{
				value:filter.curriculum,label:'curriculum',
				initial_value:'Select Curriculum'
			}
		]);
		let courses=[]
		let cor = term_data?.map((course) => {
			return (course.domain);
		})
		courses.push({value:cor});
	
		setFilterCourseData([...courses])
	}

	const FilterTableData=()=>{
		let data=CustomFilter(props?.topics?.data,[{value:filter.course,label:'course',initial_value:'Select Course'}]);
		setFilterData(data);
	}

	const columns = [ 
		{title: "Topic Code",field:"code"},
		{title: "Topic Title",field:"title"},
		{title: "Topic Content",field:"content"},
		{title: "Topic Hours",field:"hours"},
		{title: "Topic Unit",field:"unit"},
		{title: "Topic Delivery Method",field:"delivery_method"},
		{title:'Created By',field:'created_by'},
	]

	useEffect(()=>{
		Filter()
	},[filter,props?.course_curriculum])

	useEffect(()=>{
		FilterTableData()
	},[props?.course_curriculum,filterCourseData])

  	return (
		<div className='customContainer mb-5'>
      		<CustomHeading title="Topic List" />
      		<div className="row">
				<div className='col-md-4'>
					<CustomDropdown 
					label="Curriculum :"
					data={
						props?.curriculums?.data?.map((cur) => {
							return ({value: cur.name});
						})
					}
					defaultOption={'Select Curriculum'}
					notDefaultOption
					id={'curriculum'}
					onChange={handleChange}
					/>
				</div>
				<div className='col-md-4'>
					<CustomDropdown 
					label="Term :"
					data={
						props?.terms?.data?.map((term) => {
							return ({value: term.name});
						})
					}
					defaultOption={'Select Term'}
					notDefaultOption
					id={'term'}
					onChange={handleChange}
					/>
				</div>
				<div className='col-md-4'>
					<CustomDropdown 
					label="Course :"
					data={filterCourseData}
					defaultOption={'Select Course'}
					notDefaultOption
					id={'course'}
					onChange={handleChange}
					/>
				</div>
      		</div>
			<CustomTableWithAll data={filterData} title={"Topics"}  columns={columns} api="/api/Topic" identify="Topic" />
    	</div>
  	);
};

const mapActionWithProps = {
	getCurriculumData,
	getCourseCurriculumData,
	getTermsData,
	getManageTopicAndTloData,
}

const mapStateWithProps = (state) => (
	{
		curriculums:state.data.curriculums,
		course_curriculum:state.data.course_curriculum,
		terms:state.data.terms,
		topics:state.data.topics,
	}
)

export default connect(mapStateWithProps, mapActionWithProps)(Manage_Topic_Tlos);
